import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import {api} from '../../api';


export default function DealPicker({ selected, onChange }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const search = useCallback((q) => {
    if (!q || q.length < 2) { setResults([]); return; }
    api(`/deals?q=${encodeURIComponent(q)}`)
      .then(r => r.json())
      .then(data => setResults(selected ? data.filter(d => d.id !== selected.id) : data))
      .catch(() => {});
  }, [selected]);

  useEffect(() => {
    const timer = setTimeout(() => search(query), 250);
    return () => clearTimeout(timer);
  }, [query, search]);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} className="relative">
      {selected && (
        <div className="flex items-center gap-2 mb-2 p-2 bg-blue-50 rounded-lg">
          <Link to={`/crm/deals/${selected.id}`} className="text-sm font-medium text-blue-700 hover:underline">{selected.name}</Link>
          <button type="button" onClick={() => onChange(null)} className="text-blue-400 hover:text-blue-600">&times;</button>
        </div>
      )}
      {!selected && (
        <>
          <input
            type="text"
            placeholder="Search deals by name..."
            value={query}
            onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
            onFocus={() => setOpen(true)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
          {open && results.length > 0 && (
            <ul className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
              {results.map(d => (
                <li key={d.id}>
                  <button type="button" onClick={() => { onChange({ id: d.id, name: d.name }); setQuery(''); setResults([]); setOpen(false); }} className="w-full text-left px-4 py-2 hover:bg-gray-50 text-sm">
                    {d.name}
                    {d.companyName && <span className="text-gray-400"> — {d.companyName}</span>}
                  </button>
                </li>
              ))}
            </ul>
          )}
          {open && query.length >= 2 && results.length === 0 && (
            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg px-4 py-3 text-sm text-gray-500">
              No deals found
            </div>
          )}
        </>
      )}
    </div>
  );
}
